import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export async function deleteHerbicideTreatment(herbicideTreatmentId: string) {
  await companiesApi.delete(
    apiRoutes.deleteHerbicideTreatment(herbicideTreatmentId),
  )
}
